import React from 'react';
import { NeueLoadingSpinner, NeueLoadingSpinnerProps } from './spinner';
import { getJourneyUiThemeHack } from '../../helpers/themes/get-theme-color-properties';

export const NeueJourneyLoadingSpinner = (props: Omit<NeueLoadingSpinnerProps, 'theme'>) => {
  const activeJourneyTHeme = getJourneyUiThemeHack();

  return <NeueLoadingSpinner {...props} theme={activeJourneyTHeme === 'light' ? 'canvas' : 'journey'} />;
};
